import React from 'react';
import { CSS } from '@dnd-kit/utilities';
import { DraggableAttributes } from '@dnd-kit/core';
import { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities';
import type { Transform } from '@dnd-kit/utilities';
import './DashboardAvgCalcWithProgressKpiCard.scss';
import KPINumber from 'src/components/ui/KPINumber/KPINumber';
import { DashboardAvgCalcWithProgressKpi } from 'src/services/kpi';
import CardContainer from '../../layouts/CardContainer/CardContainer';

export interface DashboardAvgCalcWithProgressKpiCardProps {
  attributes?: DraggableAttributes;
  listeners?: SyntheticListenerMap;
  setNodeRef?: (node: HTMLElement | null) => void;
  transform?: Transform | null;
  transition?: string;
  data: DashboardAvgCalcWithProgressKpi;
}

const DashboardAvgCalcWithProgressKpiCard: React.FC<DashboardAvgCalcWithProgressKpiCardProps> = ({
  attributes,
  listeners,
  setNodeRef,
  transform,
  transition,
  data,
}) => {
  const style = {
    transform: CSS.Transform.toString(transform || null),
    transition,
    touchAction: 'none',
  };

  return (
    <CardContainer
      className="returnsAndReasonsCard  surface-elevated"
      ref={setNodeRef}
      style={style}
      label={data.title}
      nextArrow
      underlined
      attributes={attributes}
      listeners={listeners}>
      <KPINumber
        value={data.value.toString()}
        // TODO label?
        label=""
        // TODO pass string and color of progress directly
        percentage={Number.parseFloat(data.progress.replaceAll('%', '').trim())}
      />
    </CardContainer>
  );
};

export default DashboardAvgCalcWithProgressKpiCard;
